import { render, staticRenderFns } from "./TablePutaway.vue?vue&type=template&id=535ac3fc"
import script from "./TablePutaway.vue?vue&type=script&lang=js"
export * from "./TablePutaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports